import * as React from 'react';
import { Button, FormControl, FormGroup, Panel } from 'react-bootstrap';

interface IProps {
    isReply: boolean,
    fullName: string,
    onSend: (text: string) => void,
    onCancel: () => void
}

const Note: React.FunctionComponent<IProps> = (props) => {
    const [text, setText] = React.useState('');

    const handleNoteTextChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        setText(e.currentTarget.value);
    }

    const handleSendNote = () => {
        props.onSend(text);
    }

    const isValid = (text?.trim().length > 0);

    return (
        <Panel style={{ marginTop: props.isReply ? 20 : 0 }}>
            <Panel.Heading style={{ padding: '5px 7.5px' }}>
                <Panel.Title>{props.isReply ? 'Reply to ' : 'Send New Note to '}{props.fullName}</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
                <FormGroup validationState={!isValid ? 'error' : null}>
                <FormControl
                    componentClass='textarea'
                    style={{ height: 200, resize: 'none' }}
                    onChange={handleNoteTextChange}
                />
                </FormGroup>
                <div style={{ marginTop: 10, backgroundColor: 'white', borderTop: '0 none', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button bsStyle='primary' style={{ marginRight: 5 }} onClick={handleSendNote} disabled={!isValid}>{props.isReply ? 'Reply' : 'Send'}</Button>
                    <Button onClick={props.onCancel}>Cancel</Button>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default Note;